import React from "react";
import loaderIcon from "../../../assets/images/logo123.png";
import "./Loader.css";

const Loader: React.FC = () => {
  return (
    <div className="backdrop">
      <div className="loader">
        {/* <img src={loaderIcon} alt="Logo" className="logo" /> */}
      </div>
    </div>
  );
};

export default Loader;
